/* global debounce, windowWidth, breakpointMd, slideUp, slideDown */
window.addEventListener('load', () => {
  const tabNavParents = document.querySelectorAll('[data-tab]');
  const navTabLink = document.querySelectorAll('[data-tablink]');

  // Add height to active tab
  const activeTabHeight = () => {
    if (windowWidth() > breakpointMd) {
      const activeTabContent = document.querySelectorAll('.tab__content.is-active');
      activeTabContent.forEach((element) => {
        const tabNavParent = element.closest('[data-tab]');
        const tabContentWrapper = tabNavParent.querySelector('[data-tab-wrapper]');
        const activeTabContentHeight = `${element.clientHeight}px`;
        tabContentWrapper.style.height = activeTabContentHeight;
      });
    }
  };

  // Close tab content
  const closeTabContents = (tabNavParent) => {
    const tabContentElems = tabNavParent.querySelectorAll('[data-tab-content]');
    navTabLink.forEach((elem) => {
      elem.classList.remove('is-active');
    });
    tabContentElems.forEach((contentElem) => {
      contentElem.classList.remove('is-active');
    });
  };

  // Close tab content for mobile
  const closeTabMobile = () => {
    document.querySelectorAll('[data-tab-content].is-active').forEach((elem) => {
      elem.classList.remove('is-active');
      slideUp(elem.querySelector('[data-tab-content-inner]'), 300);
    });
  };

  activeTabHeight();

  // Debounce the function to prevent multiple executions on resize event
  const debounceTabHeight = debounce(() => {
    activeTabHeight();
  }, 500);

  window.onresize = function () {
    debounceTabHeight();
  };

  // Open specific tab
  tabNavParents.forEach((tabNavParent) => {
    const tabNavLink = tabNavParent.querySelectorAll('[data-tablink]');

    tabNavLink.forEach((el, index) => {
      el.addEventListener('click', () => {
        const tabContentWrapper = tabNavParent.querySelector('[data-tab-wrapper]');
        const targetTabContent = tabContentWrapper.querySelectorAll('[data-tab-content]')[index];

        if (windowWidth() < breakpointMd) {
          const parentTabContent = el.closest('[data-tab-content]');
          if (!parentTabContent.classList.contains('is-active')) {
            closeTabMobile();
            parentTabContent.classList.add('is-active');
            slideDown(parentTabContent.querySelector('[data-tab-content-inner]'), 300);
          } else {
            closeTabMobile();
          }
        } else {
          closeTabContents(tabNavParent);
          setTimeout(() => {
            targetTabContent.classList.add('is-active');
            const tabContentHeight = `${targetTabContent.clientHeight}px`;
            tabContentWrapper.style.height = tabContentHeight;
          }, 100);
          el.classList.add('is-active');
        }
      });
    });
  });
});
